import { _ } from '/@/locale';

export const getOverlayData = () => {
    return {
        label: _('Enfermedades, Plagas y Malezas'),
        icon: 'weeds',
        color: 'blue',
        children: [
            {
                icon: 'corn',
                label: _('Maíz'),
                color: 'orange',
                type: 'corn',
                children: [
                    { label: _('Enfermedades'), type: 'corn_diseases_historic_pressure' },
                    { label: _('Plagas'), type: 'corn_pests_historic_pressure' },
                    { label: _('Malezas'), type: 'weeds_rem' },
                    { label: _('Caracteres Agrónomicos'), type: 'corn_others' },
                ],
                id: 'corn',
            },
            {
                icon: 'circleSpodoptera',
                label: _('Pronóstico de Spodoptera'),
                type: 'spodoptera_forecast',
                color: 'orange',
                id: 'spodoptera_forecast',
            },

            {
                icon: 'humidity',
                label: _('Humedad en el suelo'),
                type: 'humidity',
                color: 'blue',
                id: 'humidity',
            },
        ],
    } as const;
};
